import { captureEvent } from "../../utils/o11y";
import { colParams } from "../utils";
import type { Action } from "./types";

/**
 * Opens the formula viewer modal.
 * Handles both cell selection and header menu (full column) contexts.
 */
export const showFormula: Action = (ctx) => {
  const col = ctx.api.getColumn(ctx.columnId);
  const params = colParams(col);
  const productId = ctx.productId || params?.productId;

  captureEvent("viewed_formula", {
    productId,
    columnId: ctx.columnId,
    rowId: ctx.rowId,
  });

  const selection =
    ctx.isHeaderMenu || ctx.selectedRange.length === 0
      ? [
          [
            {
              productId,
              columnId: ctx.columnId,
              headerName: ctx.headerName || "",
              rowId: "",
              rowIndex: 0,
              entityId: ctx.entityId || params?.entityId,
              period: "",
              cellValue: undefined,
            },
          ],
        ]
      : ctx.selectedRange;

  ctx.formulaModal.open({
    selection,
    height: 350,
    width: 600,
  });
};
